import Icon from "./icons/Icon";

/**
 * "Musik läuft" mit Equalizer bzw. "Gestoppt". Styles in Spiel.css.
 * @category spiel
 */
export function StatusPille({ laeuft, text }) {
  return (
    <span className="status-pille">
      {laeuft ? (
        <span className="equalizer" aria-hidden="true">
          <i />
          <i />
          <i />
          <i />
        </span>
      ) : (
        <Icon name="pause" size={16} />
      )}
      {text || (laeuft ? "Musik läuft" : "Gestoppt")}
    </span>
  );
}

/**
 * Drei pulsierende Punkte: "geht gleich weiter".
 * @category spiel
 */
export function WartePunkte() {
  return (
    <span className="warte-punkte" aria-hidden="true">
      <i />
      <i />
      <i />
    </span>
  );
}

export default StatusPille;
